import type {DayHoursByProject} from '@app/api-resolver/router'
import type {DonutChartProps, PieChartCell} from '@mantine/charts'
import type {Project} from '@package/shared'

export const mapDonutChart = (dayHoursByProject: DayHoursByProject[], projects: Project[]) => {
  const data = projects
    .map((project) => {
      const sum = dayHoursByProject
        .filter((item) => item.projectId === project.id)
        .reduce((sum, chartItems) => sum + chartItems.hours, 0)
      return {
        key: project.id,
        name: project.name,
        value: sum,
        color: project.color,
      } satisfies PieChartCell
    }, {})
    .filter((cell) => cell.value > 0)
    .sort((a, b) => b.value - a.value)

  return {data} satisfies Pick<DonutChartProps, 'data'>
}
